import React from 'react';
import PublicReview from './MyReviews/publicReview';

const Reputation = () => {
    return <PublicReview />;
};

export default Reputation;
